export function playJoinSound() {
  let audio = new Audio(require("../../../../assets/audio/join.mp3"));
  audio.play();
}

let audios = [
  {
    id: "swing",
    name: "Swing",
    file: new Audio(require("../../../../assets/audio/swing.mp3")),
    isPlaying: false,
  },
  {
    id: "chatsound",
    name: "Chat",
    file: new Audio(require("../../../../assets/audio/chatsound.mp3")),
    isPlaying: false,
  },
];

let activeAudio = null;
export function playEndAudio() {
  console.log("playing end audio...");
  activeAudio = audios[0];
  activeAudio.file.currentTime = 0
  activeAudio.isPlaying = true;
  activeAudio.file.volume = 0.2;
  activeAudio.file.play();
}

export function pauseSound() {
  console.log("pausing sound!");
  activeAudio.isPlaying = false;
  activeAudio.file.pause();
  activeAudio.file.currentTime = 0;
}

export function playChatMessageSound() {
  let chatAudio = null;
  chatAudio = audios[1];
  chatAudio.isPlaying = true;
  chatAudio.file.volume = 0.2;
  chatAudio.file.play();
}

export default {
  playJoinSound,
};
